import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { Camera, SecurityCamerasData } from '../data/security-cameras';
import { environment } from '../../../environments/environment';

@Injectable()
export class SecurityCamerasService extends SecurityCamerasData {
  private cmsbase_url = environment.CMSURL_IMG

  private cameras: Camera[] = [
    {
      title: 'Camera #1',
      source: this.cmsbase_url +'wp-content/uploads/2025/05/camera1.jpg',
    },
    {
      title: 'Camera #2',
      source: this.cmsbase_url +'wp-content/uploads/2025/05/camera2.jpg',
    },
    {
      title: 'Camera #3',
      source: this.cmsbase_url +'wp-content/uploads/2025/05/camera3.jpg',
    },
    {
      title: 'Camera #4',
      source: this.cmsbase_url +'wp-content/uploads/2025/05/camera4.jpg',
    },
  ];

  getCamerasData(): Observable<Camera[]> {
    return observableOf(this.cameras);
  }
}
